import type { QueryClient } from '@tanstack/react-query'

/**
 * The queries a change to a booking's life touches: the booking, its sheets,
 * the boards and the fleet. A hand-over, a return, a cancellation, a no-show,
 * a close, a refund: each leaves the Planning, Today and the lists showing it
 * as it was for up to the cache's 30 seconds otherwise (the S3 E2E found the
 * Planning still holding a cancelled booking's car).
 */
export async function refreshAfterChange(queryClient: QueryClient, code: string): Promise<void> {
  await Promise.all(
    [
      ['booking', code],
      ['checkout', code],
      ['inspection', code],
      ['today'],
      ['bookings'],
      ['timeline'],
      ['vehicles'],
    ].map((queryKey) => queryClient.invalidateQueries({ queryKey })),
  )
}
